import React, { useEffect, useState } from "react";
import PilotageLayout from "./PilotageLayout";
import { loadOrders } from "../../../data/orders";
import { getOrderFinancials } from "../../../data/payments";

const PilotageCompta = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [orders, setOrders] = useState([]);
  const [exportMonth, setExportMonth] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM

  useEffect(() => {
    let isMounted = true;
    loadOrders().then((loadedOrders) => {
      if (!isMounted) return;
      setOrders(loadedOrders || []);
      setLoaderStatus(false);
    });
    return () => { isMounted = false; };
  }, []);

  const handleExportCSV = () => {
    // Filter orders by selected month
    const targetOrders = orders.filter(o => o.date && o.date.startsWith(exportMonth));
    
    if (targetOrders.length === 0) {
      alert("Aucune transaction trouvée pour ce mois.");
      return;
    }

    // Prepare CSV data
    let csvContent = "Date,Commande,Client,Type,Total TTC,TVA,Net HT,Encaisse,Reste a Payer\n";
    
    targetOrders.forEach(order => {
      const fin = getOrderFinancials(order);
      const ht = fin.totalAmount / 1.055; // Simplified tax math
      const tva = fin.totalAmount - ht;
      
      const row = [
        order.date,
        order.id,
        order.customerType === "PRO" ? (order.customerName || "Pro") : "Standard",
        order.channel || "POS",
        fin.totalAmount.toFixed(2),
        tva.toFixed(2),
        ht.toFixed(2),
        fin.paidAmount.toFixed(2),
        fin.remainingAmount.toFixed(2)
      ].join(",");
      
      csvContent += row + "\n";
    });

    // Trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `compta_almoune_${exportMonth}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loaderStatus) {
    return (
      <PilotageLayout>
        <div className="p-6">Chargement de la comptabilité...</div>
      </PilotageLayout>
    );
  }

  return (
    <PilotageLayout>
      <div className="card border-0 shadow-sm rounded-3">
        <div className="card-header bg-white border-bottom p-4">
          <h4 className="mb-0 fw-bold text-dark">Export Comptabilité</h4>
          <p className="text-muted mb-0 small mt-1">
            Générez les exports CSV de vos ventes et encaissements pour votre expert-comptable.
          </p>
        </div>

        <div className="card-body p-5 text-center">
          <div className="mx-auto mb-4" style={{ maxWidth: "400px" }}>
            <i className="fas fa-file-csv fs-1 text-success mb-4 d-block"></i>
            <h5 className="mb-3">Générer l'export mensuel</h5>
            
            <div className="mb-4">
              <label className="form-label text-start d-block text-muted small fw-bold">Mois de l'export</label>
              <input 
                type="month" 
                className="form-control form-control-lg text-center" 
                value={exportMonth}
                onChange={(e) => setExportMonth(e.target.value)}
              />
            </div>
            
            <button 
              className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
              onClick={handleExportCSV}
            >
              <i className="fas fa-download"></i>
              Télécharger le CSV
            </button>
          </div>
          
          <div className="text-start bg-light p-3 rounded text-muted small text-start mx-auto" style={{ maxWidth: "500px" }}>
            <p className="mb-1"><i className="fas fa-info-circle me-1"></i> L'export inclut :</p>
            <ul className="mb-0">
              <li>Le détail de chaque commande sur la période</li>
              <li>La ventilation HT / TVA / TTC</li>
              <li>Le montant réellement encaissé vs le reste à payer</li>
            </ul>
          </div>
        </div>
      </div>
    </PilotageLayout>
  );
};

export default PilotageCompta;
